import * as constants from './constants'

export const getReservations = (offsetSize, pageSize, forNpsSurvey) => ({
    type: constants.GET_RESERVATIONS,
    offsetSize,
    pageSize,
    forNpsSurvey,
})

export const getMoreReservations = () => ({
    type: constants.GET_MORE_RESERVATIONS,
})

export const setReservations = result => ({
    type: constants.SET_RESERVATIONS,
    result,
})

export const setStatusFilter = status => ({
    type: constants.SET_STATUS_FILTER,
    status,
})

export const getReservationCancelAmendPolicy = reservationId => ({
    type: constants.GET_RESERVATION_CANCEL_AMEND_POLICY,
    reservationId,
})

export const setCancelReservationValues = response => ({
    type: constants.SET_CANCEL_RESERVATION_VALUES,
    response,
})

export const cancelReservation = reservationId => ({
    type: constants.CANCEL_RESERVATION,
    reservationId,
})

export const openReservationDetails = reservationId => ({
    type: constants.OPEN_RESERVATION_DETAILS,
    reservationId,
})

export const closeReservationDetails = () => ({
    type: constants.CLOSE_RESERVATION_DETAILS,
})

export const confirmCancelReservation = reservationId => ({
    type: constants.CONFIRM_CANCEL_RESERVATION,
    reservationId,
})

export const cancelReservationFailed = error => ({
    type: constants.CANCEL_RESERVATION_FAILED,
    error,
})

export const resetReservationFailedError = () => ({
    type: constants.RESET_CANCEL_RESERVATION_FAILED_ERROR,
})
export const clearCancellationState = () => ({
    type: constants.CLOSE_CANCELLATION_MODAL,
})

export const closeCancellationModal = clearCancellationState

export const cancelReservationFinished = clearCancellationState

export const changeVehicle = (reservationId, selectedVehicles) => ({
    type: constants.CHANGE_VEHICLE,
    reservationId,
    selectedVehicles,
})

export const downloadReceipt = (reservationId, receiptTab) => ({
    type: constants.DOWNLOAD_RECEIPT,
    reservationId,
    receiptTab,
})

export const updateEntity = (result, entities) => ({
    type: constants.UPDATE_ENTITY,
    result,
    entities,
})

export const changePaymentMethod = reservationId => ({
    type: constants.CHANGE_PAYMENT_METHOD,
    reservationId,
})

export const setPaymentMethod = (result, error) => ({
    type: constants.SET_PAYMENT_METHOD,
    result,
    error,
})
